'use strict';

var _ = require('../utility');

function checkIgnore(item, settings) {
  if (_.get(settings, 'plugins.jquery.ignoreAjaxErrors')) {
    return !_.get(item, 'body.message.extra.isAjax');
  }
  return true;
}

module.exports = {
  checkIgnore: checkIgnore
};



//////////////////
// WEBPACK FOOTER
// ./src/browser/predicates.js
// module id = 25
// module chunks = 0